// External libraries
import React from 'react';

// Internal modules
import { features } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { AddressForm } from './AddressForm';
import type { InputOnBlurChange, InputOnChange, InputOnFocus } from '@/types';

type AddressProps = {
  blurHandler?: InputOnBlurChange;
  changeHandler: InputOnChange;
  focusHandler?: InputOnFocus;
  showCheckboxes: boolean;
};

const Address = ({ showCheckboxes, ...props }: AddressProps): JSX.Element => {
  useMountLogging('Address');

  /**
   * Here before we render the shipToBilling checkbox we want to make sure
   * 1. change shipping address is allowed
   */
  const showShipToBilling = features.isActive('isAllowChangeShipping');

  return (
    <AddressForm
      showCheckboxes={showCheckboxes}
      showShipToBilling={showShipToBilling}
      {...props}
    />
  );
};

export { Address };
